<template>
  <div class="answer">
      <!-- <div class="logo"></div> -->
      <div class="answer-list">
            <div class="question-number">{{currentIndex+1}}</div>
            <div class="topic">{{topic}}</div>
            <div style="display: flex;flex-direction: column;align-items: center;">
                <div class="options">
                    <div class="option">A</div>
                    <div class="answer-one" :style="'background-color:'+answerOneBg+';'" @click="check(1)">{{answerOne}}</div>
                </div>
                <div class="options">
                    <div class="option">B</div>
                    <div class="answer-two" :style="'background-color:'+answerTwoBg+';'" @click="check(2)">{{answerTwo}}</div>
                </div>
                <div class="options">
                    <div class="option">C</div>
                    <div class="answer-three" :style="'background-color:'+answerThreeBg+';'" @click="check(3)">{{answerThree}}</div>
                </div>
                <div class="options">
                    <div class="option">D</div>
                    <div class="answer-four" :style="'background-color:'+answerFourBg+';'" @click="check(4)">{{answerFour}}</div>
                </div>
            </div>
            
            <div class="submit">
                <div class="on-topic" v-if="currentIndex!=0" @click="onTopic"></div>
                <div style="width:0.38rem;height:0.89rem;display: inline-block;" v-if="currentIndex!=0"></div>
                <div class="next-topic" @click="nextTopic"></div>
            </div>
      </div>
      
      <div class="tips" v-if="tips">
          请选择题目选项
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            tips:false,
            topic:'',
            answerOne:'',
            answerTwo:'',
            answerThree:'',
            answerFour:'',
            checke:-1,
            currentIndex:0,
            answerList:[],
            answerOneBg:'#f8f1ec',
            answerTwoBg:'#f8f1ec',
            answerThreeBg:'#f8f1ec',
            answerFourBg:'#f8f1ec',
            questionList:[],
            answer:'A',
            // loading:false
        }
    },
    created(){
        this.share()
        // this.loading = true
        this.questionList = JSON.parse(this.$route.query.questionList)
        this.topic = this.questionList[0].question
        this.answerOne = this.questionList[0].A
        this.answerTwo = this.questionList[0].B
        this.answerThree = this.questionList[0].C
        this.answerFour = this.questionList[0].D
        // this.loading = false
    },
    methods:{
        share(){
                    // 微信分享
            window.wx.ready(() => {
                // 分享好友
                window.wx.updateAppMessageShareData({
                title: "测测你的高考剩余值", // 分享标题
                desc: "如果重返高考考场，你到底还能拿多少分呢？", // 分享描述
                link: "https://h5case3.xiaoxxx.cn/202105/quark-answer2/index.html", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:
                    "https://h5case3.xiaoxxx.cn/202105/quark-answer/src/assets/fx.jpg", // 分享图标
                success: function () {
                    // 设置成功
                    // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数','1','1']);
                },
                });
                // 分享朋友圈
                window.wx.updateTimelineShareData({
                title: "测测你的高考剩余值", // 分享标题
                link: "https://h5case3.xiaoxxx.cn/202105/quark-answer2/index.html", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:
                    "https://h5case3.xiaoxxx.cn/202105/quark-answer/src/assets/fx.jpg", // 分享图标
                success: function () {
                    // 设置成功
                    // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数','1','1']);
                },
                });
            });
        },
        check(str){
            this.checke = str
            if(this.checke==1){
                this.answerOneBg='#ffbd3e'
                this.answerTwoBg='#f8f1ec'
                this.answerThreeBg='#f8f1ec'
                this.answerFourBg='#f8f1ec'
                this.answer = 'A'
            }else if(this.checke==2){
                this.answerOneBg='#f8f1ec'
                this.answerTwoBg='#ffbd3e'
                this.answerThreeBg='#f8f1ec'
                this.answerFourBg='#f8f1ec'
                this.answer = 'B'
            }else if(this.checke==3){
                this.answerOneBg='#f8f1ec'
                this.answerTwoBg='#f8f1ec'
                this.answerThreeBg='#ffbd3e'
                this.answerFourBg='#f8f1ec'
                this.answer = 'C'
            }else if(this.checke==4){
                this.answerOneBg='#f8f1ec'
                this.answerTwoBg='#f8f1ec'
                this.answerThreeBg='#f8f1ec'
                this.answerFourBg='#ffbd3e'
                this.answer = 'D'
            }
        },
        onTopic(){
            
            // console.log(this.answerList)
            if(this.currentIndex==1){
                // this.answerList.splice(this.currentIndex,1)
                this.currentIndex=0
                this.topic = this.questionList[0].question
                this.answerOne = this.questionList[0].A
                this.answerTwo = this.questionList[0].B
                this.answerThree = this.questionList[0].C
                this.answerFour = this.questionList[0].D
                this.checke = this.answerList[this.currentIndex].index
                this.check(this.checke)
            }else if(this.currentIndex==2){
                // this.answerList.splice(this.currentIndex,1)
                this.currentIndex=1
                this.topic = this.questionList[1].question
                this.answerOne = this.questionList[1].A
                this.answerTwo = this.questionList[1].B
                this.answerThree = this.questionList[1].C
                this.answerFour = this.questionList[1].D
                this.checke = this.answerList[this.currentIndex].index
                this.check(this.checke)
            }else if(this.currentIndex==3){
                // this.answerList.splice(this.currentIndex,1)
                this.currentIndex=2
                this.topic = this.questionList[2].question
                this.answerOne = this.questionList[2].A
                this.answerTwo = this.questionList[2].B
                this.answerThree = this.questionList[2].C
                this.answerFour = this.questionList[2].D
                this.checke = this.answerList[this.currentIndex].index
                this.check(this.checke)
            }else if(this.currentIndex==4){
                // this.answerList.splice(this.currentIndex,1)
                this.currentIndex=3
                this.topic = this.questionList[3].question
                this.answerOne = this.questionList[3].A
                this.answerTwo = this.questionList[3].B
                this.answerThree = this.questionList[3].C
                this.answerFour = this.questionList[3].D
                this.checke = this.answerList[this.currentIndex].index
                this.check(this.checke)
            }else if(this.currentIndex==5){
                // this.answerList.splice(this.currentIndex,1)
                this.currentIndex=4
                this.topic = this.questionList[4].question
                this.answerOne = this.questionList[4].A
                this.answerTwo = this.questionList[4].B
                this.answerThree = this.questionList[4].C
                this.answerFour = this.questionList[4].D
                this.checke = this.answerList[this.currentIndex].index
                this.check(this.checke)
            }else if(this.currentIndex==6){
                // this.answerList.splice(this.currentIndex,1)
                this.currentIndex=5
                this.topic = this.questionList[5].question
                this.answerOne = this.questionList[5].A
                this.answerTwo = this.questionList[5].B
                this.answerThree = this.questionList[5].C
                this.answerFour = this.questionList[5].D
                this.checke = this.answerList[this.currentIndex].index
                this.check(this.checke)
            }
        },
        initial(){
            this.checke = -1
            this.answerOneBg='#f8f1ec'
            this.answerTwoBg='#f8f1ec'
            this.answerThreeBg='#f8f1ec'
            this.answerFourBg='#f8f1ec'
        },
        nextTopic(){
            if(this.checke==-1){
                this.tips = true
                setTimeout(() => {
                    this.tips = false
                }, 1000);
                return
                // console.log('未选中答案')
            }
            if(this.currentIndex==0){
                if(this.answerList[this.currentIndex]){ //先判断是否是点击过上一题，没有的话正常执行，有的话在进行判断
                    this.topic = this.questionList[1].question
                    this.answerOne = this.questionList[1].A
                    this.answerTwo = this.questionList[1].B
                    this.answerThree = this.questionList[1].C
                    this.answerFour = this.questionList[1].D
                    if(this.answer==this.questionList[0].answer){  //如果选择的是正确答案，得分，如果选择的是错误答案不得分
                        this.answerList.splice(this.currentIndex,1,{score:20,index:this.checke})
                    }else{
                        this.answerList.splice(this.currentIndex,1,{score:0,index:this.checke})
                    }
                    this.currentIndex=1
                    if(this.answerList[this.currentIndex]){  //判断在点击上一题之前是否已经进行过选择，如果进行过选择要将选择的项展示，如果没有，则展示初始项
                        this.check(this.answerList[this.currentIndex].index)
                    }else{
                        this.initial()
                    }
                }else{
                    this.currentIndex=1
                    this.topic = this.questionList[1].question
                    this.answerOne = this.questionList[1].A
                    this.answerTwo = this.questionList[1].B
                    this.answerThree = this.questionList[1].C
                    this.answerFour = this.questionList[1].D
                    if(this.answer==this.questionList[1].answer){
                        this.answerList.push({score:20,index:this.checke})
                    }else{
                        this.answerList.push({score:0,index:this.checke})
                    }
                    this.initial()
                }
            }else if(this.currentIndex==1){
                if(this.answerList[this.currentIndex]){
                    this.topic = this.questionList[2].question
                    this.answerOne = this.questionList[2].A
                    this.answerTwo = this.questionList[2].B
                    this.answerThree = this.questionList[2].C
                    this.answerFour = this.questionList[2].D
                    if(this.answer==this.questionList[1].answer){
                        this.answerList.splice(this.currentIndex,1,{score:20,index:this.checke})
                    }else{
                        this.answerList.splice(this.currentIndex,1,{score:0,index:this.checke})
                    }
                    this.currentIndex=2
                    if(this.answerList[this.currentIndex]){
                        this.check(this.answerList[this.currentIndex].index)
                    }else{
                        this.initial()
                    }
                }else{
                    this.currentIndex=2
                    this.topic = this.questionList[2].question
                    this.answerOne = this.questionList[2].A
                    this.answerTwo = this.questionList[2].B
                    this.answerThree = this.questionList[2].C
                    this.answerFour = this.questionList[2].D
                    if(this.answer==this.questionList[1].answer){
                        this.answerList.push({score:20,index:this.checke})
                    }else{
                        this.answerList.push({score:0,index:this.checke})
                    }
                    this.initial()
                }
                
            }else if(this.currentIndex==2){
                if(this.answerList[this.currentIndex]){
                    this.topic = this.questionList[3].question
                    this.answerOne = this.questionList[3].A
                    this.answerTwo = this.questionList[3].B
                    this.answerThree = this.questionList[3].C
                    this.answerFour = this.questionList[3].D
                    if(this.answer==this.questionList[2].answer){
                        this.answerList.splice(this.currentIndex,1,{score:20,index:this.checke})
                    }else{
                        this.answerList.splice(this.currentIndex,1,{score:0,index:this.checke})
                    }
                    this.currentIndex=3
                    if(this.answerList[this.currentIndex]){
                        this.check(this.answerList[this.currentIndex].index)
                    }else{
                        this.initial()
                    }
                }else{
                    this.currentIndex=3
                    this.topic = this.questionList[3].question
                    this.answerOne = this.questionList[3].A
                    this.answerTwo = this.questionList[3].B
                    this.answerThree = this.questionList[3].C
                    this.answerFour = this.questionList[3].D
                    if(this.answer==this.questionList[2].answer){
                        this.answerList.push({score:20,index:this.checke})
                    }else{
                        this.answerList.push({score:0,index:this.checke})
                    }
                    this.initial()
                }
            }else if(this.currentIndex==3){
                if(this.answerList[this.currentIndex]){
                    this.topic = this.questionList[4].question
                    this.answerOne = this.questionList[4].A
                    this.answerTwo = this.questionList[4].B
                    this.answerThree = this.questionList[4].C
                    this.answerFour = this.questionList[4].D
                    if(this.answer==this.questionList[3].answer){
                        this.answerList.splice(this.currentIndex,1,{score:20,index:this.checke})
                    }else{
                        this.answerList.splice(this.currentIndex,1,{score:0,index:this.checke})
                    }
                    this.currentIndex=4
                    if(this.answerList[this.currentIndex]){
                        this.check(this.answerList[this.currentIndex].index)
                    }else{
                        this.initial()
                    }
                }else{
                    this.currentIndex=4
                    this.topic = this.questionList[4].question
                    this.answerOne = this.questionList[4].A
                    this.answerTwo = this.questionList[4].B
                    this.answerThree = this.questionList[4].C
                    this.answerFour = this.questionList[4].D
                    if(this.answer==this.questionList[3].answer){
                        this.answerList.push({score:20,index:this.checke})
                    }else{
                        this.answerList.push({score:0,index:this.checke})
                    }
                    this.initial()
                }
            }else if(this.currentIndex==4){
                if(this.answerList[this.currentIndex]){
                    this.topic = this.questionList[5].question
                    this.answerOne = this.questionList[5].A
                    this.answerTwo = this.questionList[5].B
                    this.answerThree = this.questionList[5].C
                    this.answerFour = this.questionList[5].D
                    if(this.answer==this.questionList[4].answer){
                        this.answerList.splice(this.currentIndex,1,{score:20,index:this.checke})
                    }else{
                        this.answerList.splice(this.currentIndex,1,{score:0,index:this.checke})
                    }
                    this.currentIndex=5
                    if(this.answerList[this.currentIndex]){
                        this.check(this.answerList[this.currentIndex].index)
                    }else{
                        this.initial()
                    }
                }else{
                    this.currentIndex=5
                    this.topic = this.questionList[5].question
                    this.answerOne = this.questionList[5].A
                    this.answerTwo = this.questionList[5].B
                    this.answerThree = this.questionList[5].C
                    this.answerFour = this.questionList[5].D
                    if(this.answer==this.questionList[4].answer){
                        this.answerList.push({score:20,index:this.checke})
                    }else{
                        this.answerList.push({score:0,index:this.checke})
                    }
                    this.initial()
                }
                
            }else if(this.currentIndex==5){
                if(this.answer==this.questionList[5].answer){
                    this.answerList.push({score:20,index:this.checke})
                }else{
                    this.answerList.push({score:0,index:this.checke})
                }
                // console.log(this.answerList)
                let num = 0
                this.answerList.map((v)=>{
                    return num += v.score
                })
                // console.log(num)
                this.$router.push({path:'/result',query:{score:num}})
            }
        }
    }
}
</script>

<style scoped>
.options{
    /* display: flex; */
    margin-bottom: 0.5rem;
    
    /* margin: 0 auto; */
}
.options:after{
    content:"";
    display:block;
    clear:both;
    height:0;
    overflew:hidden;
}
.option{
    width: 0.6rem;
    height: 0.6rem;
    font-family: siyuan;
    border: solid 0.04rem #df7333;
    border-radius: 0.08rem;
    line-height: 0.6rem;
    text-align: center;
    font-size: 0.3rem;
    font-weight: bold;
    background-color: #f8f1ec;
    /* margin-bottom: 0.24rem; */
    float: left;
}
.logo{
    width: 1.57rem;
    height: 0.48rem;
    background: url('../assets/logo.png') no-repeat center;
    background-size: cover;
    position: absolute;
    left: 0.5rem;
    top: 0.3rem;
}
.answer{
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    background: url('../assets/answer-bg.png') no-repeat center;
    background-size: cover;
}
.tips{
    position: fixed;
    left: 0;
    right: 0;
    margin: 0 auto;
    /* transform: translateX(-50%); */
    width: 3rem;
    height: 0.5rem;
    text-align: center;
    line-height: 0.5rem;
    font-size: 0.24rem;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 0.05rem;
    color: #ffffff;
    bottom: 50% ;
}
.answer-list{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    /* top: calc(50% - 6rem); */
    /* transform: translateX(-50%); */
    font-size: 0.3rem;
    text-align: left;
    width: 100%;
    height: 12rem;
    /* box-sizing: border-box;
    padding: 0 1rem; */
}
.question-number{
    width: 0.6rem;
    height: 0.62rem;
    background: url('../assets/title-bg.png') no-repeat center;
    background-size: cover;
    font-size: 0.4rem;
    font-weight: bold;
    color: #d7783f;
    text-align: center;
    line-height: 0.6rem;
    margin: 0 auto;
}
.topic{
    text-align: left;
    margin: 0.4rem auto 0.56rem;
    font-size: 0.4rem;
    color: #ce7037;
    width: 6rem;
    font-family: huakang;
}
/* .answer-list div{
    margin: 0.3rem 0;
} */
.answer-one,.answer-two,.answer-three,.answer-four{
    background-color: #f8f1ec;
    color: #000000;
    font-size: 0.26rem;
    font-family: siyuan;
    border: solid 0.04rem #df7333;
    border-radius: 0.08rem;
    box-sizing: border-box;
    padding: 0.12rem 0.28rem;
    /* text-align: center; */
    width: 4rem;
    float: left;
    /* max-width: 4.5rem;
    min-width: 3rem; */
    /* margin: 0 auto; */
    line-height: 0.36rem;
    margin-left: 0.44rem;
}
.submit{
    /* position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: calc(50% - 4.5rem); */
    font-size: 0.3rem;
    width: 100%;
    justify-content: center;
    display: inline-block;
    text-align: center;
    /* margin: 0 auto; */
    /* display: flex; */
}
/* .submit:after{
    content:"";
    display:block;
    clear:both;
    height:0;
    overflew:hidden;
} */
.on-topic{
    width: 2.24rem;
    height: 0.89rem;
    background: url('../assets/on-topic.png') no-repeat center;
    background-size: cover;
    /* float: left; */
    display: inline-block;
}
.next-topic{
    width: 2.24rem;
    height: 0.89rem;
    background: url('../assets/next-topic.png') no-repeat center;
    background-size: cover;
    /* float: left; */
    display: inline-block;
}
/* .answer-two{
    margin: 0.24rem auto;
} */
.options:nth-child(4){
    /* margin-top: 0.24rem; */
    margin-bottom: 0.74rem;
}
</style>